import postscribe from 'postscribe';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';

export class GoogleDoubleClick extends Component {
  renderGDC() {
    const gdc = this.props.googleDoubleClick;

    if (this.props.block) {
      gdc.gdcSlotOneId && this.runPostscribe(gdc.gdcSlotOneId);
      gdc.gdcSlotTwoId && this.runPostscribe(gdc.gdcSlotTwoId);
      gdc.gdcSlotThreeId && this.runPostscribe(gdc.gdcSlotThreeId);
      gdc.gdcFooterId && this.runPostscribe(gdc.gdcFooterId);
    } else {
      gdc.gdcHeaderId && this.runPostscribe(gdc.gdcHeaderId);
    }
  }

  runPostscribe(id) {
    setTimeout(() => {
      postscribe(`#${id}`, `<script type='text/javascript'>
          googletag.cmd.push(function () {
          googletag.display('${id}');
        });
        </script>`);
    }, 50);
  }

  addGDCHTML(id) {
    return (
      <div className="unit size-1of3 tac">
        <div id={id} className="upsell-banner" />
      </div>
    );
  }

  addGDCHeaderHTML(id) {
    return (
      <div className="GoogleDoubleClick__header line tac">
        <div id={id} className="main-content-banner" />
      </div>
    );
  }

  addGDCFooterHTML(id) {
    return (
      <div className="line tac gfa-block">
        <div id={id} className="main-content-banner" />
      </div>
    );
  }

  componentDidMount() {
    if (this.props.googleDoubleClick) {
      this.renderGDC();
    }
  }

  render() {
    const gdc = this.props.googleDoubleClick;

    if (!gdc) {
      return null;
    }

    if (this.props.block) {
      return (
        <>
          <div className="GoogleDoubleClick__block line co-step">
            {gdc.gdcSlotOneId && this.addGDCHTML(gdc.gdcSlotOneId)}
            {gdc.gdcSlotTwoId && this.addGDCHTML(gdc.gdcSlotTwoId)}
            {gdc.gdcSlotThreeId && this.addGDCHTML(gdc.gdcSlotThreeId)}
          </div>
          {gdc.gdcFooterId && this.addGDCFooterHTML(gdc.gdcFooterId)}
        </>
      );
    }
    return gdc.gdcHeaderId && this.addGDCHeaderHTML(gdc.gdcHeaderId);
  }
}

const mapStateToProps = state => ({
  googleDoubleClick: state.start.siteDataV2.googleDoubleClick,
});

GoogleDoubleClick.propTypes = {
  block: PropTypes.bool,
  googleDoubleClick: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
)(GoogleDoubleClick);
